import { Component, OnInit, OnDestroy, inject, signal, NgZone } from '@angular/core';
import { LoaderService } from '../services/loader.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-loader-spinner',
    template: `<div class="loading" *ngIf="loading()">
  </div>`,
    standalone: false
})
export class LoaderSpinnerComponent implements OnInit, OnDestroy {
  private loaderService = inject(LoaderService);
  private ngZone = inject(NgZone);

  loading = signal(false);
  pamentLoader = signal(false);

  private sub1: Subscription;
  private sub2: Subscription;

  ngOnInit(): void {
    this.sub1 = this.loaderService.loader.subscribe((res) => {
      this.ngZone.run(() => {
        this.loading.set(res);
      });
    });
    this.sub2 = this.loaderService.secondaryLoader.subscribe((res) => {
      this.ngZone.run(() => {
        this.pamentLoader.set(res);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.sub1) this.sub1.unsubscribe();
    if (this.sub2) this.sub2.unsubscribe();
  }
}
